import React, { useState } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import darkTheme from './themes/dark';
import { PrivateRoute, ProvideAuth } from "./other/auth";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Login from "./components/Login";
import NavBar from "./components/NavBar";
import SideBar from "./components/SideBar/SideBar"
import AccountInfo from "./components/AccountInfo";
import Live from "./components/Live/Live"
import Epg from "./components/Epg/Epg";
import Groups from "./components/Group/Groups";
import Search from "./components/Search/Search";
import MainVod from "./components/Vod/MainVod";
import CommandsLoader from "./components/App/CommandLoader";

function App() {
  if (window.location.protocol !== 'https:' && window.https === true)
    window.location = window.location.href.replace("http", "https");
  else if (window.location.protocol === 'https:' && window.https === false)
    window.location = window.location.href.replace("https", "http");

  let url = window.location.hash.replace("#", "");

  console.log(window.location)

  return (
    <ThemeProvider theme={darkTheme}>
      <ProvideAuth>
        <Router>
          <Switch>
            <Route>
              <Route path="/:playingMode/">
                <NavBar />
                <SideBar />
                <Groups />
              </Route>
              <PrivateRoute exact path="/">
                <Live />
              </PrivateRoute>

              <Switch>
                <PrivateRoute exact path="/:playingMode/category/:category/"></PrivateRoute>
                <PrivateRoute exact path="/live/category/:category/:category/epg/"><Epg /></PrivateRoute>
              </Switch>

              <Switch>
                <PrivateRoute exact path="/:playingMode/category/:category/search/"><Search /></PrivateRoute>
                <PrivateRoute exact path="/:playingMode/search/"><Search /></PrivateRoute>
              </Switch>
              <Switch>
              <PrivateRoute exact path="/live/category/:category/epg/"><Epg /></PrivateRoute>
                <PrivateRoute exact path="/live/category/:category/channel/:channel/epg/"><Epg /></PrivateRoute>
                <PrivateRoute exact path="/live/category/:category/channel/:channel/epg/categories/"><Epg /></PrivateRoute>
              </Switch>

              <Switch>
                <Route path="/login/"><Login url={url} /></Route>
                <PrivateRoute exact path="/info/"><AccountInfo /></PrivateRoute>
                <PrivateRoute path="/live/category/:category/channel/:channel/"><Live /></PrivateRoute>
                <PrivateRoute path="/live/category/:category/"><Live /></PrivateRoute>
                <PrivateRoute path="/live/"><Live /></PrivateRoute>
                <PrivateRoute path="/:playingMode/category/:category/"><MainVod /></PrivateRoute>
                <PrivateRoute path="/:playingMode/"><MainVod /></PrivateRoute>
              </Switch>
            </Route>
          </Switch>
        </Router>
      </ProvideAuth>
      <CommandsLoader />
    </ThemeProvider>
  );
}

export default App;
